import Notifications from "./Notifications"
import NotificationsFetch from "../NotificationsFetch/NotificationsFetch"

export default Notifications

export { NotificationsFetch }
